import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from "../../errors/api-error-handler";
import {
  TaxonomyInitialStateType,
  TaxonomyType,
} from "../../models/taxonomy-model";
import TaxonomyService from "../../services/taxonomy.service";

const initialState: TaxonomyInitialStateType = {
  data: [],
  loading: true,
  error: undefined,
};

export const retrieveTaxonomy = createAsyncThunk(
  "taxonomy/retrieve",
  async () => {
    const response = await TaxonomyService.getTaxonomyList();
    return [...response.data.result];
  }
);

const taxonomySlice = createSlice({
  name: "taxonomy",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(retrieveTaxonomy.pending, (state) => {
        state.loading = true;
      })
      .addCase(retrieveTaxonomy.fulfilled, (state, action) => {
        if (action.payload) {
          state.loading = false;
          state.data = action.payload as TaxonomyType[];
        }
      })
      .addCase(retrieveTaxonomy.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = apiErrorHandler(Number(payload));
      });
  },
});

export const selectAllEntities = (state: { entities: any }) => state.entities;
export default taxonomySlice.reducer;
